import { Controller, Shark } from "shark-mvc";
import i18next from "i18next";
import moment from "moment";

import transalationResource from "../../locales/";

class LocalizationManager extends Controller {
	#defaultLanguage = "it";

	constructor () {
		super("localizationManager");
	}

	extractLabels (i18n, parent, parentName = "") {
		const labels = {};

		for (const currProp in parent) {
			if (typeof parent[currProp] === "string") {
				labels[currProp] = i18n((parentName ? parentName + "." : "") + currProp);
			}
			else {
				labels[currProp] = this.extractLabels(i18n, parent[currProp], parentName ? parentName + "." + currProp : currProp);
			}
		}

		return labels;
	}

	init () {
		// ora anche async
		i18next.init({
			debug: false,
			lng: this.#defaultLanguage,
			resources: transalationResource,
		})
		.then(i18n => {
			const activeLnaguageCode = localStorage.preferredLocale || this.#defaultLanguage;
	
			Shark.set({
				i18n,
				transalationResource,
			});
			localizationManager.setActiveLanguage(activeLnaguageCode);
		});
	}
	
	async setActiveLanguage (languageCode) {
		if (languageCode !== Shark.get("activeLnaguageCode")) {
			localStorage.setItem("preferredLocale", languageCode);

			moment.locale(languageCode);

			return i18next
			.changeLanguage(languageCode)
			.then(i18n => {
				const transalationResource = Shark.get("transalationResource");
				const labels = this.extractLabels(i18n, transalationResource[languageCode].translation);

				// console.log({labels, languageCode});

				Shark.set({
					activeLnaguageCode: languageCode,
					active_language_en: languageCode === "en",
					active_language_it: languageCode === "it",
					i18n,
					labels,
				});
				Shark.render();
				localizationManager.emit("languageChanged", languageCode);
			});
		}
	}
}

const localizationManager = new LocalizationManager();

Shark.registerController(localizationManager);

export default localizationManager;
